import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmpfs/builds/maltcommunity/malt/apps/malt/resources-center/resources-center-front/app/layouts/default.vue").then(m => m.default || m))
}